/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Validator } from '@squiz/dxp-console-support';

const expr = /^(\/[a-z0-9\\-_.%~]+)((\/:\{\*\})*(\/[a-z0-9\\-_.%~]+)*)*$/i;

/**
 * Validates a value against a collection path prefix regular expression.
 * @template R
 */
export class DatastoreCollectionValidator<R> extends Validator<string, R> {
  public doValidate(path: string): boolean {
    return expr.test(String(path).trim());
  }
}
